import axios from 'axios';

// Use relative path when in production (served by backend)
// This will use the same domain as the frontend
const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api'  // Uses same domain (https://media.feedmebaby.com/api)
  : 'http://localhost:5555/api';

export const api = axios.create({
  baseURL: API_URL,
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
};